// ─── Badge ────────────────────────────────────────────────────────────────────
export function Badge({ text, type }) {
  const styles = {
    'Normal': 'bg-green-100 text-green-700',
    'Perlu Perhatian': 'bg-yellow-100 text-yellow-700',
    'Risiko Tinggi': 'bg-red-100 text-red-700',
    'Aktif': 'bg-green-100 text-green-700',
    'Tidak Aktif': 'bg-gray-100 text-gray-500',
  };
  return (
    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold ${styles[text] || 'bg-gray-100 text-gray-600'}`}>
      {text}
    </span>
  );
}

// ─── Avatar ───────────────────────────────────────────────────────────────────
export function Avatar({ initials, size = 'md' }) {
  const sizes = { sm: 'w-8 h-8 text-xs', md: 'w-10 h-10 text-sm', lg: 'w-14 h-14 text-lg' };
  return (
    <div className={`${sizes[size]} rounded-full bg-primary-800 text-white flex items-center justify-center font-display font-700 flex-shrink-0`}>
      {initials}
    </div>
  );
}

// ─── Card ─────────────────────────────────────────────────────────────────────
export function Card({ children, className = '', ...rest }) {
  return (
    <div className={`bg-white rounded-2xl border border-gray-100 shadow-sm ${className}`} {...rest}>
      {children}
    </div>
  );
}

// ─── SectionTitle ─────────────────────────────────────────────────────────────
export function SectionTitle({ children }) {
  return (
    <h3 className="font-display font-700 text-gray-900 text-base mb-4">{children}</h3>
  );
}

// ─── EmptyState ───────────────────────────────────────────────────────────────
export function EmptyState({ icon: Icon, message }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-gray-400">
      <Icon className="w-10 h-10 mb-3 opacity-30" />
      <p className="text-sm">{message}</p>
    </div>
  );
}

// ─── StatCard ─────────────────────────────────────────────────────────────────
export function StatCard({ label, value, sub, icon: Icon, color }) {
  return (
    <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-sm flex items-center gap-4">
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${color}`}>
        <Icon className="w-6 h-6" />
      </div>
      <div>
        <p className="text-xs text-gray-500 mb-0.5">{label}</p>
        <p className="font-display font-800 text-xl text-gray-900">{value}</p>
        {sub && <p className="text-xs text-gray-400">{sub}</p>}
      </div>
    </div>
  );
}
